// src/legal/LegalPage.jsx
// Renders the Privacy Policy or the Terms of Service, signed in or not.
//
// Reached by URL hash (#privacy, #terms) — src/App.jsx checks the hash before AuthGate,
// so the pages need no session and no router. Links to them open in a new tab from
// inside the app (LegalLinks), so reading the terms never unmounts the dashboard or
// the acceptance screen the reader came from.

import React from 'react';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import Value from './Value';
import { legalIdentity, formatLegalDate } from './legalConfig';
import './LegalPage.css';

const DOCS = {
  privacy: { title: 'Privacy Policy',   Body: PrivacyPolicy, other: ['terms', 'Terms of Service'] },
  terms:   { title: 'Terms of Service', Body: TermsOfService, other: ['privacy', 'Privacy Policy'] },
};

export default function LegalPage({ doc }) {
  const { title, Body, other } = DOCS[doc] || DOCS.terms;
  const id = legalIdentity();
  const unconfigured = Object.values(id).some(v => v.missing);

  return (
    <div className="lg-wrap">
      <article className="lg-doc">
        <a className="lg-back" href="/">← Back to the app</a>
        <h1 className="lg-title">{title}</h1>
        <p className="lg-updated"><Value v={id.product} /> · Last updated {formatLegalDate()}</p>

        {unconfigured && (
          <div className="lg-draft" role="note">
            Some details on this page have not been configured for this deployment yet and
            are marked “TO CONFIRM”.
          </div>
        )}

        <Body id={id} />

        <footer className="lg-footer">
          <a href={`#${other[0]}`}>{other[1]}</a>
        </footer>
      </article>
    </div>
  );
}
